import createContainer from 'constate';
import { requests } from '../../utils/DataUtil';
import config from '../../config';

export const andromedaURL = `${config.pronvest.api.url}Andromeda`;

const AndromedaModule = () => {
  const signalRConfig = {
    hubName: 'Andromeda',
    hubUrl: config.pronvest.signalR.andromedaHubUrl,
    hubGroups: {
      jobUpdates: {
        name: 'Andromeda Job Updates',
        joinGroupMethodName: 'JoinAndromedaJobUpdatesGroup',
        listenerMethods: {
          updateJob: 'UpdateJob',
        },
      },
      agentUpdates: {
        name: 'Andromeda Agent Updates',
        joinGroupMethodName: 'JoinAndromedaAgentUpdatesGroup',
        listenerMethods: {
          createAgent: 'CreateAgent',
          updateAgent: 'UpdateAgent',
          updateAgentCircuitBreaker: 'UpdateAgentCircuitBreaker',
        },
      },
    },
  };

  return {
    signalRConfig,
    getAgents: async () => {
      const res = await requests.GET(`${andromedaURL}/Agents`);
      if (res.ok) return await res.json();
      else return null;
    },
    updateAgent: async (id, agentDto) => {
      const res = await requests.PUT(`${andromedaURL}/Agents/${id}`, agentDto);
      if (res.ok) return true;
      return false;
    },
    createAgent: async (name, loginUrl, hasCaptcha, allowsMultipleNumbers) => {
      var dto = {
        name,
        loginUrl,
        hasCaptcha,
        allowsMultipleNumbers,
      };
      const res = await requests.POST(`${andromedaURL}/Agents`, dto);
      if (res.ok) return await res.json();
      return false;
    },
    getJobExplorerFilterOptions: async () => {
      const res = await requests.GET(`${andromedaURL}/Jobs/FilterOptions`);
      if (res.ok) return await res.json();
      return false;
    },
    getJob: async (id) => {
      const res = await requests.GET(`${andromedaURL}/Jobs/${id}`);
      if (res.ok) return await res.json();
      return false;
    },
    getJobs: async (searchParams) => {
      const res = await requests.GET(`${andromedaURL}/Jobs?${searchParams}`);
      if (res.ok) return await res.json();
      return false;
    },
    sendJobInstruction: async (id, instruction) => {
      await requests.POST(
        `${andromedaURL}/Jobs/${id}/Instruction`,
        instruction
      );
    },
    getPlaywrightTrace: async (jobId) => {
      const res = await requests.GET(
        `${andromedaURL}/Jobs/${jobId}/PlaywrightTrace`
      );
      if (!res.ok) {
        let message;
        switch (res.status) {
          case 400:
            message = 'Invalid IP address, please connect to the vpn';
            break;
          case 403:
            message = "You don't have permission to perform this action";
            break;
          case 404:
            message = await res.text();
            break;
          default:
            message = 'Unable to download playwright trace';
            break;
        }
        return { success: false, message };
      }

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = `playwright-trace-${jobId}.zip`;
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      return { success: true, message: null };
    },
    getPlaywrightVideo: async (jobId) => {
      const res = await requests.GET(
        `${andromedaURL}/Jobs/${jobId}/PlaywrightVideo`
      );
      if (!res.ok) {
        let message;
        switch (res.status) {
          case 400:
            message = 'Invalid IP address, please connect to the vpn';
            break;
          case 403:
            message = "You don't have permission to perform this action";
            break;
          case 404:
            message = await res.text();
            break;
          default:
            message = 'Unable to download playwright video';
            break;
        }
        return { success: false, message };
      }

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = `playwright-video-${jobId}.mp4`;
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      return { success: true, message: null };
    },
  };
};

const [Provider, useAndromeda] = createContainer(AndromedaModule);

export { useAndromeda };

export default Provider;
